import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { motion } from 'framer-motion';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

export default function Forbidden403({
                                         title = '403 — Доступ запрещён',
                                         message = 'У вас нет прав для просмотра этой страницы. Возможно, вы не вошли в систему или у вас недостаточно прав. Если это ошибка, обратитесь в поддержку или вернитесь на главную.',
                                         primaryAction = { label: 'На главную', href: '/' },
                                         secondaryAction = { label: 'Обновить', onClick: () => window.location.reload() },
                                         supportAction = { label: 'Связаться с поддержкой', href: 'mailto:support@example.com' }
                                     }) {
    const containerStyle = {
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f9fafb, #ffffff)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
    };

    const cardStyle = {
        maxWidth: '900px',
        width: '100%',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
        borderRadius: '16px',
        overflow: 'hidden'
    };

    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        alignItems: 'center'
    };

    const leftStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #ffffff, #f3f4f6)',
        padding: '2rem'
    };

    const textSectionStyle = {
        padding: '2rem'
    };

    const footerStyle = {
        marginTop: '1.5rem',
        textAlign: 'center',
        color: '#6b7280',
        fontSize: '0.9rem'
    };

    return (
        <div style={containerStyle}>
            <motion.div
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45 }}
                style={{ width: '100%', maxWidth: '900px' }}
            >
                <Card style={cardStyle}>
                    <div style={gridStyle}>
                        <div style={leftStyle}>
                            <svg viewBox="0 0 120 120" width="180" height="180">
                                <defs>
                                    <linearGradient id="g1" x1="0" x2="1" y1="0" y2="1">
                                        <stop offset="0%" stopColor="#6366f1" />
                                        <stop offset="100%" stopColor="#06b6d4" />
                                    </linearGradient>
                                </defs>
                                <rect x="6" y="30" width="108" height="72" rx="10" fill="#eef2ff" />
                                <path d="M60 34c7 0 12 5 12 12v6" stroke="url(#g1)" strokeWidth="4" strokeLinecap="round" fill="none" />
                                <circle cx="60" cy="72" r="10" fill="#fff" stroke="url(#g1)" strokeWidth="3" />
                                <path d="M74 54l24-16" stroke="#fb923c" strokeWidth="4" strokeLinecap="round" />
                            </svg>
                        </div>

                        <div style={textSectionStyle}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                <div style={{ background: '#eef2ff', borderRadius: '50%', padding: '0.75rem' }}>
                                    <i className="pi pi-lock" style={{ color: '#4f46e5', fontSize: '1.5rem' }}></i>
                                </div>
                                <h1 style={{ fontSize: '1.75rem', fontWeight: '600', color: '#1f2937' }}>{title}</h1>
                            </div>

                            <Divider style={{ margin: '1rem 0' }} />

                            <p style={{ color: '#4b5563', marginBottom: '1.5rem', lineHeight: '1.6' }}>{message}</p>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                                <Button
                                    label={primaryAction.label}
                                    icon="pi pi-home"
                                    style={{ borderRadius: '30px', fontSize: '1rem', padding: '0.75rem 1.5rem' }}
                                    onClick={() => (primaryAction.href ? (window.location.href = primaryAction.href) : primaryAction.onClick && primaryAction.onClick())}
                                />

                                <Button
                                    label={secondaryAction.label}
                                    icon="pi pi-refresh"
                                    className="p-button-outlined"
                                    style={{ borderRadius: '30px', fontSize: '1rem', padding: '0.75rem 1.5rem' }}
                                    onClick={() => secondaryAction.onClick && secondaryAction.onClick()}
                                />

                                <Button
                                    label={supportAction.label}
                                    icon="pi pi-envelope"
                                    className="p-button-text"
                                    style={{ borderRadius: '30px', fontSize: '1rem', padding: '0.75rem 1.5rem' }}
                                    onClick={() => (supportAction.href ? (window.location.href = supportAction.href) : supportAction.onClick && supportAction.onClick())}
                                />
                            </div>

                            <div style={{ marginTop: '1rem', color: '#9ca3af', fontSize: '0.8rem' }}>
                                Если вы считаете, что это ошибка, приложите скриншот и укажите, на какой странице возникла проблема.
                            </div>
                        </div>
                    </div>
                </Card>

                <div style={footerStyle}>© {new Date().getFullYear()} Ваша компания — Все права защищены</div>
            </motion.div>
        </div>
    );
}
